/**
 * TRIDOO — Carosello media della scheda prodotto.
 *
 * Usa lo stesso Swiper del tema (FoxTheme.Carousel) così frecce, pallini e
 * comportamento touch sono quelli di tutte le altre sezioni di Hyper. Il
 * markup è già nel Liquid; qui si accende soltanto. Con meno di due slide
 * non si inizializza: il Liquid non lo stampa nemmeno, ma il controllo resta
 * per l'editor del tema.
 */
if (!customElements.get('tridoo-carosello')) {
  customElements.define(
    'tridoo-carosello',
    class TridooCarosello extends HTMLElement {
      connectedCallback() {
        this.swiperEl = this.querySelector('.swiper');
        if (!this.swiperEl) return;
        if (this.swiperEl.querySelectorAll('.swiper-slide').length < 2) return;
        if (window.FoxTheme && FoxTheme.Carousel) {
          this.avvia();
        } else {
          // theme.js è deferred come questo file, ma nell'editor del tema una
          // sezione può essere reiniettata prima che sia pronto.
          document.addEventListener('DOMContentLoaded', () => this.avvia(), { once: true });
        }
      }

      disconnectedCallback() {
        if (this.carousel && this.carousel.slider) this.carousel.slider.destroy(true, true);
        this.carousel = null;
      }

      avvia() {
        if (this.carousel || !window.FoxTheme || !FoxTheme.Carousel) return;
        const perRiga = Math.max(1, parseInt(this.dataset.perRiga, 10) || 4);
        const controlli = this.querySelector('.swiper-controls');
        const opzioni = {
          slidesPerView: 1.15,
          spaceBetween: 12,
          loop: false,
          watchOverflow: true,
          breakpoints: {
            750: { slidesPerView: Math.min(2, perRiga), spaceBetween: 16 },
            990: { slidesPerView: perRiga, spaceBetween: 20 }
          },
          ...(controlli && {
            navigation: {
              nextEl: controlli.querySelector('.swiper-button-next'),
              prevEl: controlli.querySelector('.swiper-button-prev')
            },
            pagination: {
              el: controlli.querySelector('.swiper-pagination'),
              clickable: true
            }
          })
        };
        this.carousel = new FoxTheme.Carousel(this.swiperEl, opzioni);
        this.carousel.init();
        // Il CSS pre-avvio (slide in fila, gap) va tolto appena Swiper
        // comanda lui: la classe la mettiamo noi, senza dipendere dalla
        // versione di Swiper nel bundle del tema.
        this.swiperEl.classList.add('swiper-initialized');
      }
    }
  );
}
